/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";

import loadingConfig from "./config/loading.config.json";
import { IGetHolderGroupProps } from "./components";
import { IAddGroupMethodsProps } from "./components";

const is = require("is_js");

const SERVICE_NAME = "PayoutPageService";
const log: any = LoggerModule.getInstance();

export class PayoutPageService {
  private static instance: PayoutPageService;
  private vapp: VApplication;
  private criteria: any;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): PayoutPageService {
    if (!PayoutPageService.instance) {
      PayoutPageService.instance = new PayoutPageService(props);
    }
    return PayoutPageService.instance;
  }

  private setCriteria(data: any) {
    this.criteria = data;
  }

  public resetCriteria() {
    this.criteria = null;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getPageContent(args: IGetHolderGroupProps) {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    if (args?.criteria) {
      this.setCriteria(args?.criteria);
    }

    //Header Props
    compProps = await agent.getHeaderProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }
    //addCountry Props
    compProps = await agent.getCountryProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //Settings Props
    compProps = await agent.getSettingsProps({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    //UserLists Props
    compProps = await agent.getAppCardListProps({
      ...args,
      criteria: { ...this.criteria, ...args?.criteria },
    });
    if (compProps) {
      console.log(`inside service`, compProps);
      content = { ...content, ...compProps };
    }

    return content;
  }

  public getLoading() {
    return { ...(loadingConfig || {}) };
  }

  public async addGroup(args: IAddGroupMethodsProps) {
    log.info(`add Group`, args);
    const agent = getAgent();
    return agent.getAddGroup(args);
  }
}
